/* global ymaps, helper, bases_search, main, region, base, contacts */

var loadMapScript = (function() {
    var yaMapLoaded = false;

    return function(method, condition) {
        if (!yaMapLoaded && condition) {
            var script = document.createElement("script");
            script.src = "//api-maps.yandex.ru/2.1/?lang=ru_RU&onload=" + method;
            $('body').prepend(script);
            yaMapLoaded = true;
        }
    }
})();

$(function(){
    map.init();
});

var map = {};
map.geolocation;

map.init = function(){
    if (window.main_page) {
        $(window).scroll(function() {
            loadMapScript('main_page.map_init', $(window).scrollTop() > 700);
        });
    }

    bases_search.map_init();

    // регион
    if(window.region && window.region.map_init){
        loadMapScript('region.map_init', true);
    }

    // тип курортов
    if(window.resort_type && window.resort_type.map_init){
        loadMapScript('resort_type.map_init', true);
    }

    // курорт
    if(window.resort && window.resort.map_init){
        loadMapScript('resort.map_init', true);
    }

    // водоем
    if(window.water && window.water.map_init){
        loadMapScript('water.map_init', true);
    }

    // турбаза
    if(window.base && typeof base.insert_map_image !== 'undefined'){
        base.insert_map_image();
        $('#map').one('mouseenter', function() {
            loadMapScript('', true);
        });
    }

    // контакты
    if(window.contacts && window.contacts.map_insert){
        loadMapScript('contacts.map_insert', true);
    }
};

map.insert = function(el_id, options){
    if(!options) options = {};

    let options_def = {
        center: [55.74954, 37.621587],
        zoom: 10,
        behaviors: ['drag', 'dblClickZoom', 'multiTouch'],
        controls: ['zoomControl'],
    };
    if(helper.isMobile()){
        options_def.controls = [];
    }
    options = $.extend(false, options_def, options);

    // Создание экземпляра карты и его привязка к контейнеру с
    let $map = new ymaps.Map(el_id, options);

    $map.controls.add('zoomControl', {position: {right: '25px', bottom: '60px'}, size: "small"});

    $map.options.set('suppressMapOpenBlock', true);
    return $map;
};

map.clusterer = function(options){
    if(!options) options = {};

    var options_def = {
        /**
         * Через кластеризатор можно указать только стили кластеров,
         * стили для меток нужно назначать каждой метке отдельно.
         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/option.presetStorage.xml
         */
        preset: 'islands#invertedVioletClusterIcons',
        /**
         * Ставим true, если хотим кластеризовать только точки с одинаковыми координатами.
         */
        groupByCoordinates: false,
        /**
         * Опции кластеров указываем в кластеризаторе с префиксом "cluster".
         * @see https://api.yandex.ru/maps/doc/jsapi/2.1/ref/reference/ClusterPlacemark.xml
         */
        clusterDisableClickZoom: false,
        clusterHideIconOnBalloonOpen: false,
        geoObjectHideIconOnBalloonOpen: false,
        preset: 'islands#invertedDarkGreenClusterIcons'
    };

    options = $.extend(true, options_def, options);

    return clusterer = new ymaps.Clusterer(options);
};

function isElement(obj){
    try{
        //Using W3 DOM2 (works for FF, Opera and Chrom)
        return obj instanceof HTMLElement;
    }
    catch(e){
        //Browsers not supporting W3 DOM2 don't have HTMLElement and
        //an exception is thrown and we end up here. Testing some
        //properties that all elements have. (works on IE7)
        return (typeof obj === "object") &&
            (obj.nodeType === 1) && (typeof obj.style === "object") &&
            (typeof obj.ownerDocument === "object");
    }
}